import { forwardRef, useContext } from 'react'
import { StyledTabsList } from '../styled-components'
import { TabsContext } from './tabs-context'

const TabsList = forwardRef((props, forwardedRef) => {
  const { ...listProps } = props
  const context = useContext(TabsContext)

  return (
    <StyledTabsList
      role="tablist"
      {...listProps}
      ref={forwardedRef}
      data-loading={context.loading ? '' : undefined}
    />
  )
})

TabsList.displayName = 'TabsList'
export default TabsList
